<template>
  <div id="app">
    <IncidentTimeline 
      v-if="currentView === 'timeline'" 
      @navigate="handleNavigation"
    />
    <IncidentDetails 
      v-if="currentView === 'details'" 
      @navigate="handleNavigation"
    />
  </div>
</template>

<script>
import { ref } from 'vue';
import IncidentTimeline from './views/IncidentTimeline.vue';
import IncidentDetails from './views/IncidentDetails.vue';

export default {
  name: 'App',
  components: {
    IncidentTimeline,
    IncidentDetails
  },
  setup() {
    const currentView = ref('timeline');

    const handleNavigation = (view) => {
      currentView.value = view;
    };

    return {
      currentView,
      handleNavigation
    };
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  background: #F2F2F7;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  max-width: 375px;
  margin: 0 auto;
  min-height: 100vh;
  background: white;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

/* Mobile viewport fixes */
@media (max-width: 375px) {
  #app {
    max-width: 100%;
    box-shadow: none;
  }
}
</style>